module.exports = __webpack_public_path__ + "888f259c7f0f3c325d4dfc253a21514a.fbx";